// import React, { createContext, useContext, useState, useEffect } from 'react';

// const AuthContext = createContext(null);

// const HR_EMAIL = 'gurpreet@densitypharmachem.com';
// const HOD_CODE = '1001';

// const deriveRoles = (userData) => ({
//   ...userData,
//   isHR: userData.email?.toLowerCase() === HR_EMAIL.toLowerCase(),
//   isHOD: userData.employeeCode === HOD_CODE,
//   isManager: userData.isManager || false,
// });

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [token, setToken] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const storedToken = localStorage.getItem('token');
//     const storedUser = localStorage.getItem('user');
//     if (storedToken && storedUser) {
//       setToken(storedToken);
//       setUser(JSON.parse(storedUser));
//     }
//     setLoading(false);
//   }, []);

//   const login = (userData, jwtToken) => {
//     const enrichedUser = deriveRoles(userData);
//     setUser(enrichedUser);
//     setToken(jwtToken);
//     localStorage.setItem('token', jwtToken);
//     localStorage.setItem('user', JSON.stringify(enrichedUser));
//   };

//   const updateUserRoles = (isManager) => {
//     setUser((prev) => {
//       const updated = { ...prev, isManager };
//       localStorage.setItem('user', JSON.stringify(updated));
//       return updated;
//     });
//   };

//   const logout = () => {
//     setUser(null);
//     setToken(null);
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//   };

//   return (
//     <AuthContext.Provider value={{ user, token, loading, login, logout, updateUserRoles }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);


import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setUnauthorizedHandler } from '../config/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      try {
        const payload = JSON.parse(atob(storedToken.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setToken(storedToken);
          setUser(JSON.parse(storedUser));
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/login?expired=true', { replace: true });
        }
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login?expired=true', { replace: true });
      }
    }
    setLoading(false);
  }, [navigate]);

  const login = (userData, jwtToken) => {
    // isManager/isHOD/isHR come pre-computed from the backend login response —
    // don't recompute them here, the server is the source of truth for role checks.
    setUser(userData);
    setToken(jwtToken);
    localStorage.setItem('token', jwtToken);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const updateUserRoles = (isManager) => {
    setUser((prev) => {
      const updated = { ...prev, isManager };
      localStorage.setItem('user', JSON.stringify(updated));
      return updated;
    });
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  // ===== SESSION EXPIRY HANDLER =====
  // Registered once; any 401 from api.js triggers this — clears session and
  // redirects to login with a message so unsaved-work confusion never repeats.
  useEffect(() => {
    setUnauthorizedHandler(() => {
      setUser(null);
      setToken(null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      navigate('/login?expired=true', { replace: true });
    });
  }, [navigate]);

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, updateUserRoles }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);